// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__6q5m-","colMin":"styles_colMin__3UqHO","colCheckbox":"styles_colCheckbox__3V_TB"};